export function profileRoleLabel(
  role: string | undefined,
  isStudyCentre: boolean,
  strings: { roleGuardian: string; roleLearner: string; roleStudent: string },
): string {
  if (role === "guardian") return strings.roleGuardian;
  if (isStudyCentre) return strings.roleLearner;
  return strings.roleStudent;
}
